import axios from 'axios';
import Cookies from 'js-cookie';

export async function refreshToken() {
  try {
    const refreshToken = Cookies.get('refresh_token');
    const response = await axios.post(
      // `${process.env.REACT_APP_KEYCLOAK_URL}/auth/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/protocol/openid-connect/token`, //DEV
      `${process.env.REACT_APP_KEYCLOAK_URL_UAT}/auth/realms/${process.env.REACT_APP_KEYCLOAK_REALM_UAT}/protocol/openid-connect/token`, //UAT
      {
        grant_type: 'refresh_token',
        //DEV
        // client_id: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
        // client_secret: process.env.REACT_APP_KEYCLOAK_CLIENT_SECRET,
        //UAT
        client_id: process.env.REACT_APP_KEYCLOAK_CLIENT_ID_UAT,
        client_secret: process.env.REACT_APP_KEYCLOAK_CLIENT_SECRET_UAT,

        refresh_token: refreshToken,
      },
    );
    // console.log('refreshToken response data', response.data);
    const { access_token, refresh_token } = response.data;
    Cookies.set('access_token', access_token);
    Cookies.set('refresh_token', refresh_token);

    return access_token;
  } catch (error) {
    console.error('Failed to refresh token', error);
    throw error;
  }
}
